import { render, staticRenderFns } from "./BloqueIndex.vue?vue&type=template&id=267f3e4a"
import script from "./BloqueIndex.vue?vue&type=script&lang=js"
export * from "./BloqueIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports